import { render, staticRenderFns } from "./robotStatustucs.vue?vue&type=template&id=53dbb320&scoped=true"
import script from "./robotStatustucs.vue?vue&type=script&lang=js"
export * from "./robotStatustucs.vue?vue&type=script&lang=js"
import style0 from "./robotStatustucs.vue?vue&type=style&index=0&id=53dbb320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dbb320",
  null
  
)

export default component.exports